import { DtoBase } from "../DtoBase";
import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { ApiKeyDto } from "./ApiKeyDto";

export class GetApiKeysResultDto extends DtoBase {

	public ApiKeys: List<ApiKeyDto>;

	constructor() {
		super();

		this.ApiKeys = new List<ApiKeyDto>();
	}

	public get HasApiKeys(): boolean {
		return (!!this.ApiKeys && this.ApiKeys.Count > 0);
	}

	public Write(obj: any, context: any): void {
		obj.get_api_keys_result = {};
		obj = obj.get_api_keys_result;

		super.Write(obj, context);

		if (this.HasApiKeys) {
			obj.api_keys = [];
			ObjSerUtils.WriteObjSerCollection(obj.api_keys, this.ApiKeys, context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.get_api_keys_result)
			throw new Error();
		obj = obj.get_api_keys_result;

		super.Read(obj, context);

		if (obj.api_keys !== undefined) {
			this.ApiKeys = new List<ApiKeyDto>();
			ObjSerUtils.ReadObjSerCollection(obj.api_keys, this.ApiKeys,
												(value: any) => new ApiKeyDto(), context);
		}
	}

}